<template>
  <q-page>
    <div>  
      <UserList></UserList>
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import UserList from '@/components/User/UserList.vue'
export default {
  name: 'User',
  components: {
    UserList,
  },
  data: function () {
    return {
      
    }
  }
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
